import { lazy, Suspense, useEffect } from 'react';

/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import { Route, Switch, withRouter, useLocation } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import { getProfileDetails } from './store/actions/AuthActions';
import { getRolePermissionsData } from './store/actions/RoleActions';
import { getPendingCountData } from './store/actions/TimeCardActions';
import { generatePasswordAction } from './store/actions/AuthActions';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import "./css/custom.css";


const Congratulations = lazy(() => import('./jsx/pages/Congratulations'));
const SetupProfile = lazy(() => import('./jsx/pages/SetupProfile'));
const EmpLogin = lazy(() => import('./jsx/pages/EmpLogin'));
const AnnualSubscribtion = lazy(() => import('./jsx/pages/AnnualSubscribtion'));
const FreeSubscribtion = lazy(() => import('./jsx/pages/FreeSubscribtion'));
const CompanyInfo = lazy(() => import('./jsx/pages/CompanyInfo'));
const SetPassword = lazy(() => import('./jsx/pages/SetPassword'));
const Otp = lazy(() => import('./jsx/pages/Otp'));
const ResisterEmail = lazy(() => import('./jsx/pages/ResisterEmail'));
const InitialScreen = lazy(() => import('./jsx/pages/InitialScreen'));
const ResetPassword = lazy(() => import('./jsx/pages/ResetPassword'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const SignUp = lazy(() => import('./jsx/pages/Registration'));
const GeneratePassword = lazy(() => import('./jsx/pages/GeneratePassword'));
const Login = lazy(() => import('./jsx/pages/Login'));
const TermsConditions = lazy(() => import('./jsx/pages/TermsConditions'));
const UserAgreement = lazy(() => import('./jsx/pages/UserAgreement'));
const PrivacyPolicy = lazy(() => import('./jsx/pages/PrivacyPolicy'));

function App(props) {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        dispatch(getRolePermissionsData(props.history));
        const pathname = location.pathname.split("/")[1];
        if (pathname === "generate-password") {
            dispatch(generatePasswordAction(props.history));
        } else {
            checkAutoLogin(dispatch, callBack, props.history);
        }
    }, [dispatch, props.history]);

    const callBack = (data) => {
        if (data) {
            dispatch(getProfileDetails(props.history));
            dispatch(getPendingCountData(props.history));
        }

    }

    let routes = (

        <Switch>
            {/* <Route path='/initial' component={InitialScreen} /> */}
            <Route path='/login' component={Login} />
            <Route path='/page-register' component={SignUp} />
            <Route path='/forgot-password' component={ForgotPassword} />
            <Route path='/reset-password' component={ResetPassword} />
            <Route path='/generate-password/:id' component={GeneratePassword} />
            <Route path='/resister-email' component={ResisterEmail} />
            <Route path='/otp' component={Otp} />
            <Route path='/set-password' component={SetPassword} />
            <Route path='/company-information' component={CompanyInfo} />
            <Route path='/free-subscribtion' component={FreeSubscribtion} />
            <Route path='/annual-subscribtion' component={AnnualSubscribtion} />
            <Route path='/emp-login' component={EmpLogin} />
            <Route path='/setup-profile' component={SetupProfile} />
            <Route path='/congratulations' component={Congratulations} />
            <Route path='/terms-conditions' component={TermsConditions} />
            <Route path='/user-agreement' component={UserAgreement} />
            <Route path='/privacy-policy' component={PrivacyPolicy} />
        </Switch>
    );

    if (props.isAuthenticated) {
        return (
            <>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    <Index />
                </Suspense>
            </>
        );
    } else {
        return (
            <div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    {routes}
                </Suspense>
            </div>
        );
    }


};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App));

